"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _ChevronLeft = _interopRequireDefault(require("@material-ui/icons/ChevronLeft"));

var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));

var _PdfDialog = _interopRequireDefault(require("./PdfDialog"));

var _useWindowSize = _interopRequireDefault(require("./hooks/useWindowSize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var PdfDialogWithNav = function PdfDialogWithNav(_ref) {
  var isOpen = _ref.isOpen,
      pdfSrc = _ref.pdfSrc,
      onClose = _ref.onClose;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      nbPages = _useState2[0],
      setNbPages = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      activePage = _useState4[0],
      setActivePage = _useState4[1];

  var size = (0, _useWindowSize["default"])();
  (0, _react.useEffect)(function () {
    setNbPages(0);
    setActivePage(pdfSrc.start ? pdfSrc.start.page : 0);
  }, [pdfSrc]);

  var _pdfSrc = pdfSrc.document ? pdfSrc.document.src : pdfSrc;

  var gotoPage = function gotoPage() {
    var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return function () {
      setActivePage((activePage + amount) % nbPages);
    };
  };

  var nextPage = gotoPage(1);
  var prevPage = gotoPage(-1);
  return /*#__PURE__*/_react["default"].createElement(_PdfDialog["default"], {
    width: size.width - 64,
    height: size.height - 64 - 48,
    isOpen: isOpen,
    pdfSrc: _pdfSrc,
    onClose: onClose,
    nbPages: nbPages,
    setNbPages: setNbPages,
    activePage: activePage,
    renderButtons: /*#__PURE__*/_react["default"].createElement(_core.Box, {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center"
    }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
      onClick: prevPage,
      disabled: activePage <= 0
    }, /*#__PURE__*/_react["default"].createElement(_ChevronLeft["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "caption"
    }, activePage + 1, " / ", nbPages), /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
      onClick: nextPage,
      disabled: activePage >= nbPages - 1
    }, /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null)))
  });
};

_PdfDialog["default"].propTypes = {
  pdfSrc: _propTypes["default"].string.isRequired
};
var _default = PdfDialogWithNav;
exports["default"] = _default;